const PROD_API_BASE = 'https://api.visime.com';

function trimEnv(value: string | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

/**
 * Resolve the Laravel API origin.
 * Never fall back to the web SPA origin (visime.com) — nginx serves index.html for /api/*
 * which breaks login (checkEmail returns HTML 200).
 */
export function resolveApiBaseUrl(): string {
  const fromEnv =
    trimEnv(process.env.REACT_APP_API_URL) || trimEnv(process.env.VITE_API_URL);
  if (fromEnv) {
    return fromEnv.replace(/\/$/, '');
  }

  if (typeof window === 'undefined') {
    return PROD_API_BASE;
  }

  const { hostname, origin } = window.location;
  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.local')
  ) {
    return origin;
  }

  return PROD_API_BASE;
}
